import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BranchWithUserData } from '../../commonTypes/acs/organization-types';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';

export interface BranchesWithUsersDataState {
    value: BranchWithUserData[];
}

const initialState: BranchesWithUsersDataState = {
    value: [],
};

export const branchSlice = createSlice({
    name: 'branch',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setBranchesWithUserData: (state, action) => {
            state.value = action.payload;
        },
        addBranchWithUserData: (state, action) => {
            state.value.push(action.payload);
        },
        setBranchAsMain: (state, action) => {
            const { branchId } = action.payload;
            state.value.forEach(branchWithUserData => {
                if (branchWithUserData.branch.isMain === true) {
                    branchWithUserData.branch.isMain = false;
                }
                if (branchWithUserData.branch.id === branchId) {
                    branchWithUserData.branch.isMain = true;
                }
            });
        },
        deleteBranch: (state, action: PayloadAction<string>) => {
            const branchDataToDel = state.value.find(branchData => branchData.branch.id === action.payload);
            const mainBranchData = state.value.find(branchData => branchData.branch.isMain);

            if (!branchDataToDel || !mainBranchData) return;

            state.value = state.value
                .filter(brachData => brachData.branch.id !== action.payload)
                .map(branchData => {
                    if (!branchData.branch.isMain) return { ...branchData };

                    let updatedMain = { ...branchData };
                    updatedMain.userData.usersCount += branchDataToDel.userData.usersCount;

                    const maxUsersToTransfer = 3 - updatedMain.userData.users.length;
                    if (maxUsersToTransfer <= 0) return updatedMain;

                    let transferredUsersCount = 0;
                    for (const user of branchDataToDel.userData.users) {
                        updatedMain.userData.users.push(user);
                        transferredUsersCount++;
                        if (transferredUsersCount === maxUsersToTransfer) break;
                    }

                    return updatedMain;
                });
        },
    },
});

export const { setBranchesWithUserData, addBranchWithUserData, setBranchAsMain, deleteBranch } = branchSlice.actions;

export const selectBranchesWithUserData = (state: RootState) => state.branch.value;

export default branchSlice.reducer;
